import { useEffect, useRef } from "react";
import Pusher from "pusher-js";
import { useStore } from "@state/store";
import allUnits from "./units";
import { useFavoritesStore } from "@state/favouritesStore";
import { useLocation } from "react-router-dom";

const LightsBroadcaster = (): JSX.Element => {
  const channel = useRef<any>(null);
  const location = useLocation();
  const isFavourites = location.pathname.includes("favourites");
  const isResidences = location.pathname === "/residences";

  const filteredUnits = useStore((state) => state.filteredUnits);
  const selectedUnit = useStore((state) => state.selectedUnit);
  const selectedRows = useStore((state) => state.selectedRows);
  const { favorites } = useFavoritesStore((state) => state);
  const isActive = (unit: any) => {
    return unit.status === "Available" && unit.floor !== 23;
  };

  useEffect(() => {
    const pusher = new Pusher("3f9a103314dd39424d49", {
      cluster: "eu",
      authEndpoint:
        "https://llco-leyton-dev.ew.r.appspot.com/paddington/pusher/auth",
    });
    channel.current = pusher.subscribe("private-llco-leyton-dev");
  }, []);

  useEffect(() => {
    let lightsOn: string[] = [];
    let lightsOff: string[] = [];

    const determineLights = () => {
      // If not on the `/residences` route, turn ALL lights on.
      if (!isResidences) {
        lightsOn = allUnits.map((item) => item.addr);
      } else {
        // Otherwise, keep your existing logic.
        if (isFavourites) {
          if (favorites.length === 0) {
            lightsOn = allUnits.map((item) => item.addr);
          } else if (selectedRows?.length > 0) {
            lightsOn = selectedRows.map((unit: any) => unit?.id);
          } else {
            lightsOn = favorites.map((unit: any) => unit?.id);
          }
        } else {
          if (selectedUnit?.length > 0) {
            lightsOn = selectedUnit.map((unit: any) => unit.id);
          } else if (filteredUnits?.length > 0) {
            lightsOn = filteredUnits
              ?.filter((unit: any) => isActive(unit))
              .map((unit: any) => unit.id);
          } else if (selectedRows?.length > 0) {
            lightsOn = selectedRows.map((unit: any) => unit.id);
          } else {
            lightsOn = allUnits.map((item) => item.addr);
          }
        }
      }

      // Lights to turn off = all not in `lightsOn`
      lightsOff = allUnits
        .filter((item) => !lightsOn.includes(item.addr))
        .map((item) => item.addr);
    };

    determineLights();

    // Only trigger if the next set differs from the last
    if (JSON.stringify(lightsOn) !== channel.current?.lastOn) {
      channel.current?.trigger("client-zones-on", { zones: lightsOn });
      channel.current.lastOn = JSON.stringify(lightsOn);
    }

    if (JSON.stringify(lightsOff) !== channel.current?.lastOff) {
      setTimeout(() => {
        channel.current?.trigger("client-zones-off", { zones: lightsOff });
        channel.current.lastOff = JSON.stringify(lightsOff);
      }, 100);
    }

    return () => {
      channel.current?.unbind("client-zones-on");
      channel.current?.unbind("client-zones-off");
    };
  }, [
    selectedUnit,
    filteredUnits,
    selectedRows,
    favorites,
    isFavourites,
    isResidences,
  ]);

  return <div />;
};

export default LightsBroadcaster;
